/**
 * authEvents.js — Système d'événements d'authentification
 *
 * Permet à n'importe quel composant de signaler qu'un utilisateur s'est
 * connecté ou déconnecté. Les composants qui écoutent cet événement
 * (ex: Navbar) se mettent à jour automatiquement sans rechargement de page.
 *
 * Utilisation :
 *   import { notifyAuthUserChanged } from '../../utils/authEvents';
 *   notifyAuthUserChanged(); // après login ou logout
 */

// Nom de l'événement utilisé partout dans l'application
export const AUTH_USER_CHANGED_EVENT = 'exp-auth-user-changed';

// Émet l'événement sur window pour prévenir tous les écouteurs actifs
export function notifyAuthUserChanged() {
	if (typeof window === 'undefined') {
		return; // garde pour SSR / tests Node
	}

	window.dispatchEvent(new Event(AUTH_USER_CHANGED_EVENT));
}
